module.exports = "#define GLSLIFY 1\n\nattribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 filterMatrix;\n\nvarying vec2 vTextureCoord;\nvarying vec2 vFilterCoord;\n\nvoid main(void){\n\tgl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\tvFilterCoord = (filterMatrix * vec3(aTextureCoord, 1.0)).xy;\n\tvTextureCoord = aTextureCoord;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/assets/js/distortion/main.vert
// module id = wVmX
// module chunks = 1